import type { StorageService } from '../../../../types/azureStorage';
import type { StorageServiceFolderAction } from '../../../database-objects/services/storageTreeExtensions';

export function s2ServiceFolderActionRows(service: StorageService): readonly StorageServiceFolderAction[] {
  return service === 'blob' ? [{ id: 'create-container', label: 'Create container…' }] : [];
}
